const h = "ag-cell", m = (e) => Array.from(
  e.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  )
).filter((t) => t.tabIndex !== -1), E = (e) => {
  const t = [];
  let s = e.target;
  for (; s; )
    t.push(s), s = s.parentElement;
  return t;
}, p = ({ event: e }) => {
  const { key: t, shiftKey: s } = e, d = E(e), o = t === "Tab" && s === !1, f = t === "Tab" && s === !0;
  let c = !1;
  if (o || f) {
    const l = d.find((i) => i.classList === void 0 ? !1 : i.classList.contains(h));
    if (!l)
      return c;
    const n = m(l), a = n[n.length - 1], u = n[0];
    if (n.length === 0)
      return !1;
    const r = n.indexOf(
      document == null ? void 0 : document.activeElement
    );
    o ? a && (document == null ? void 0 : document.activeElement) === a || (c = !0, (r !== -1 || (document == null ? void 0 : document.activeElement) === l) && (e.preventDefault(), n[r + 1].focus())) : (l.contains(document == null ? void 0 : document.activeElement) && l !== (document == null ? void 0 : document.activeElement) || (a.focus(), e.preventDefault()), u && (document == null ? void 0 : document.activeElement) === u || (c = !0, (r !== -1 || (document == null ? void 0 : document.activeElement) === l) && (e.preventDefault(), n[r - 1].focus())));
  }
  return c;
};
export {
  p as suppressKeyboardEvent
};
//# sourceMappingURL=index.es5532.js.map
